import { Box, makeStyles } from "@material-ui/core";
import { useThemeBreakpoints } from "api";
import { Form, Formik } from "formik";
import { useSnackbar } from "notistack";
import React from "react";
import { useSelector } from "react-redux";
import { useFirebase } from "react-redux-firebase";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import { RootState } from "redux/model";
import { LOGIN_ERROR_MESSAGES } from "redux/reducers/authReducer";
import {
    InputFieldFormik,
    SubmitButton,
    Subtitle,
    Title,
} from "ui/componentes";

const useStyles = makeStyles((theme) => ({
    marginTop: {
        marginTop: theme.spacing(2),
    },
    marginLeft: {
        marginLeft: theme.spacing(1),
    },
}));

const ForgetPassword = () => {
    const classes = useStyles();
    const { isDownXs } = useThemeBreakpoints();
    const firebase = useFirebase();
    const { auth } = useSelector((state: RootState) => state.firebase);
    const { enqueueSnackbar } = useSnackbar();

    if (auth.uid) {
        return <Redirect to="/" />;
    }
    return (
        <Box
            id="signIn"
            width="100%"
            height="100vh"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            bgcolor="#F5F5F5"
        >
            <img
                src={`${process.env.PUBLIC_URL}/img/irb_logo.png`}
                style={{ maxHeight: isDownXs ? 100 : 120 }}
                alt="logo_irb"
            />
            <Box minWidth={600}>
                <Box width="100%" padding={3}>
                    <Formik
                        initialValues={{ email: "" }}
                        onSubmit={({ email }, { setSubmitting }) => {
                            firebase
                                .auth()
                                .sendPasswordResetEmail(email, {
                                    url: window.location.origin,
                                })
                                .then(() => {
                                    enqueueSnackbar(
                                        `Um email foi enviado para ${email} para redefinição de senha!`,
                                        { variant: "success" }
                                    );
                                    setSubmitting(false);
                                })
                                .catch((error) => {
                                    if (error.code === "auth/invalid-email") {
                                        enqueueSnackbar(
                                            LOGIN_ERROR_MESSAGES[error.code],
                                            { variant: "error" }
                                        );
                                    } else {
                                        enqueueSnackbar(
                                            `Um email foi enviado para ${email} para redefinição de senha!`,
                                            { variant: "success" }
                                        );
                                    }
                                    setSubmitting(false);
                                });
                        }}
                    >
                        {() => (
                            <Form>
                                {/* <Message
                                message={"TEste"}
                                variant="error"
                                show={true}
                            /> */}
                                <Title
                                    text="Esqueceu a senha?"
                                    className={classes.marginTop}
                                />
                                <InputFieldFormik
                                    required
                                    autoFocus
                                    id="email"
                                    name="email"
                                    label="Email"
                                    margin="normal"
                                    className={classes.marginTop}
                                />
                                <SubmitButton
                                    fullWidth
                                    size="large"
                                    className={classes.marginTop}
                                >
                                    Solicitar alteração de senha
                                </SubmitButton>
                            </Form>
                        )}
                    </Formik>
                    <Box display="flex" marginTop={2}>
                        <Link to="/sign-in">
                            <Subtitle text="Ir para login" color="primary" />
                        </Link>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export { ForgetPassword };
